import React, { useContext } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { Doughnut } from "react-chartjs-2";
import { ThemeModeContext } from "../../shared/Theme";
import { useNavigate } from "react-router-dom";
import { red, amber, green } from "../../shared/colours";
import Chart from 'chart.js/auto';

const RiskOverviewGraph = (props) => {
	
	const navigate = useNavigate();
	const themeModeContext = useContext(ThemeModeContext);
	
	const value = props.value;
	const remaining = props.total - value;
	const percentage = (value / props.total) * 100;
	const higherIsBetter = (props.hasOwnProperty('higherIsBetter'))? (props.higherIsBetter === "true") : true;
	
	let color = red;
	if (props.colorOverride) {
		switch (props.colorOverride) {
			case "red":
				color = red;
				break;
			case "amber":
				color = amber;
				break;
			case "green":
				color = green;
				break;
			default:
				color = red;
		}
	}
	else {
		if (higherIsBetter) {
			if (percentage >= 33) color = amber;
			if (percentage >= 50) color = green;
		}
		else {
			if (percentage <= 50) color = amber;
			if (percentage <= 33) color = green;
		}
	}
	
	const bgDoughnut = {
		data: {
			datasets: [{
				data: [100],
				backgroundColor: [
					(themeModeContext.themeMode === "light")? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.1)"
				],
				borderWidth: 0,
			}]
		},
		options: {
			animation: {
				duration: 0
			},
			cutout: "90%"
		}
	};
	
	const fgDoughnut = {
		data: {
			datasets: [{
				data: [value, remaining],
				backgroundColor: [
					color,
					"rgba(0, 0, 0, 0)"
				],
				borderWidth: 0,
				borderRadius: 5
			}]
		},
		options: {
			cutout: "90%"
		}
	};
	
	const handleClick = () => {
		navigate(props.link);
	}
	
	return (
		<Box
			onClick={handleClick}
			sx={{
				position: "relative",
				minWidth: props.size,
				minHeight: props.size,
				cursor: "pointer"
			}}
		>
			<Box sx={{ position: "absolute", top: 0, width: "100%", height: "100%" }}>
				<Doughnut data={bgDoughnut.data} options={bgDoughnut.options} width="100%" height="100%"/>
			</Box>
			<Box sx={{ position: "absolute", top: 0, width: "100%", height: "100%" }}>
				<Doughnut data={fgDoughnut.data} options={fgDoughnut.options} width="100" height="100"/>
			</Box>
			<Grid
				container
				spacing={0}
				direction="column"
				alignItems="center"
				justifyContent="center"
				sx={{ position: "absolute", top: "50%", transform: "translate(0, -50%)" }}
			>
				<Grid item xs={2}>
					<Typography variant="h2" sx={{ width: "100%", textAlign: "center", color: "text.primary" }}>
						{props.value}
					</Typography>
				</Grid>
			</Grid>
		</Box>
	);
	
};

export default RiskOverviewGraph;